import React from 'react';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';
import TableComponent from '../../../Common/Charts/TableCharts';

export const Table = () => {
    const { chartData, isLoading } = useServicesChartsDataContext();

    const columns = [
        {
            key: 'description',
            header: 'Idade',
            headerStyle: {
                width: '50%',
                fontWeight: '500'
            },
            cellStyle: {}
        },
        {
            key: 'services',
            header: 'Qtd AIH',
            headerStyle: {
                width: '50%',
                textAlign: 'right',
                fontWeight: '500'
            },
            cellStyle: {
                textAlign: 'right'
            },
            formatter: (value) => number.formatToBRNumber(value)
        }
    ];

    if (isLoading) return null;

    return (
        <div className="chart-container-dashboards">
            <TableComponent
                className="w-100"
                data={chartData?.selectedYear || []}
                columns={columns}
                title="Quantidade de AIH por Idade"
                showTotal={true}
                totalColumn={'services'}
                maxHeight="400px"
                isLastTotal={true}
            />
        </div>
    );
};
